/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LicenseBenefitHubDiscountsResponse {
    getFixupPrototypeFunction() { return LicenseBenefitHubDiscountsResponse.fixupPrototype; }

    static newInstance(model: Partial<LicenseBenefitHubDiscountsResponse>): LicenseBenefitHubDiscountsResponse {
        let obj = Object.assign(new LicenseBenefitHubDiscountsResponse(), model);
        LicenseBenefitHubDiscountsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LicenseBenefitHubDiscountsResponse>): LicenseBenefitHubDiscountsResponse {
        if (!model) return null;
        return LicenseBenefitHubDiscountsResponse.newInstance(<LicenseBenefitHubDiscountsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LicenseBenefitHubDiscountsResponse) {
        if (!obj) return;

        models.LicenseBenefitHubDiscountsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LicenseBenefitHubDiscountsResponse): boolean {
        Object.setPrototypeOf(obj, LicenseBenefitHubDiscountsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.summary_data) {
            for (let val of this.summary_data) {
                models.LicenseSummaryData.fixupPrototype(val);
            }
        }
    }

    /**
     * total count of records
     */
    total_count: number;

    /**
     * total number of page count
     */
    page_count: number;

    /**
     * Data Summary
     */
    summary_data: Array<models.LicenseSummaryData>;

}
